import styled from "styled-components";
import { Modal, Col } from "antd";
import { GhostButtonComponent, UnderlineLink } from "../../../../CommonComponents/commonStyles";

export const LinkForModal = styled(UnderlineLink)`
  display: block;
  font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
  font-size: ${props => props.theme.fontSize.primary} !important;
  line-height: ${props => props.theme.lineHeight.primary} !important;
  text-decoration: underline;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const CloseButton = styled(GhostButtonComponent)`
  width: 150px;
  margin: 0 auto;
  @media only screen and (max-width: 990px) {
    width: 150px !important;
  }
  @media(max-width: 576px){
    font-size: ${props => props.theme.fontSize.primary} !important;
  }
`;

export const AccessModal = styled(Modal)`
 
  &.ant-modal {
    @media only screen and (max-width: 1023px){
      max-width: calc(100vw - 44px);
      margin: 8px auto;
    }
    @media only screen and (min-width: 768px){
      width: 1067px !important;
      max-width: calc(100vw - 44px);
      margin: 8px auto;
    }
  }
  &&& {
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-header {
      padding: 30px;
      background: #fff;
      border-bottom: none;
      border-radius: unset;
      @media (max-width: 576px) {
        padding: 10px 30px 10px 15px;
        font-size: ${props => props.theme.fontSize.h5};
      }
    }
    .ant-modal-title {
      text-align: center;
      font-family: ${props => props.theme.fontFamily.berkeleyStd};
      font-size: ${props => props.theme.fontSize.h3};
      font-weight: ${props => props.theme.fontWeight.normal};
      line-height: ${props => props.theme.lineHeight.h4};
      color: ${props => props.theme.fontColors.headingColor};
      letter-spacing: ${props => props.theme.letterSpacing.normal};
      @media (max-width: 576px) {
        font-size: ${props => props.theme.fontSize.h4};
        margin-top:25px;
        margin-bottom:15px;
      }
    }
    .ant-modal-body {
      padding: 0 30px 0px 30px;
      @media (max-width: 767px) {
        overflow-y: auto;
      }
      @media (max-width: 576px) {
        padding: 0 15px 20px 15px;
        height: 300px;
      }
    }
    .ant-modal-footer {
      padding: 20px 16px 30px 16px;
      text-align: center;
      border-top: none !important;
      border-radius: 0 0 4px 4px;
    }
    .ant-modal-close {
      display: none !important;
      @media only screen and (max-width: 767px) {
        display: block !important;
        right:10px;
        top:-5px;
      }
    }
    .ant-modal-close-x{
      font-size: ${props => props.theme.fontSize.h5};
      @media only screen and (max-width:576px) {
        width: 30px;
        height: 30px;
      }
    }
    .anticon-close.ant-modal-close-icon{
      @media only screen and (max-width:576px){
      vertical-align: middle;
      }
    }
  }
`;

export const AccessTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  border: 1px solid ${props => props.theme.border.popupTableBorder};
`;

export const SmallerGreyGradient = styled.div`
  // position: absolute;
  // bottom: 0;
  height: 10%;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
`;

export const TableHeading = styled.th`
  border: 1px solid ${props => props.theme.border.popupTableBorder};
  text-align: center;
  padding: 4px;
  min-width: 150px;
  border-top: none;
  border-left: none;
`;

export const TableColumnHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
`;

export const TableLastHeading = styled.th`
  border-bottom: 1px solid ${props => props.theme.border.popupTableBorder};
  border-right: none !important;
  text-align: center;
  padding: 4px;
  min-width: 109px;
`;

export const TableData = styled.td`
  border-right: 1px solid ${props => props.theme.border.filledTabsInactive};
  border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
  text-align: right;
  padding: 5px 10px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
`;

export const TableLastData = styled.td`
  border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
  text-align: right;
  padding: 8px 27px;
`;

export const TableRow = styled.tr`
    th {
      border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
      border-right: 1px solid ${props => props.theme.border.filledTabsInactive};
      text-align: center;
      padding: 4px;
      font-weight: ${props => props.theme.fontWeight.normal};
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      color: #022737;
    }
`;

export const BlueCircle = styled.div`
  width: 12px;
  height: 12px;
  background-color: #006778;
  border-radius: 50%;
  margin: auto;
`;

export const GreenCircle = styled.div`
  width: 12px;
  height: 12px;
  background-color: #69923a;
  border-radius: 50%;
  margin: auto;
`;

export const LightGreenCircle = styled.div`
  width: 12px;
  height: 12px;
  background-color: #a8b400;
  border-radius: 50%;
  margin: auto;
`;
export const MixedCircle = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  background-color:  ${props => props.theme.backgroundColor.mixedCircle};
  border-radius: 50%;
  margin: auto;
`;
/*********************************** MOBILE ************************************************/

export const WhiteAccessCard = styled.div`
  
  padding: 15px 15px;
  .ant-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const GreyAccessCard = styled.div`
  background-color: #eaeaea;
  padding: 15px 15px;
  .ant-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
`;

export const MobileBlueCircle = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${props => props.theme.colors.primaryColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.white};
`;

export const MixedMobileCircle = styled.div`
  width: 25px;
  height: 25px;
  background-color:${props => props.theme.backgroundColor.mixedCircle};
  position:relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.white};
  flex-shrink:0;
`;

export const Mixedindex = styled.div`
    z-index: 99;
`;

export const MobileGreenCircle = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${props => props.theme.colors.secondaryColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.white};
`;

export const MobileLightGreenCircle = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${props => props.theme.colors.lightGreen};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.white};
`;
export const TableHeadingFirst = styled.th`
  min-width: 108px;
`;
export const TableHeadingSecond = styled.th`
  min-width: 108px;
`;
export const TableHeadingLimited = styled.th`
  min-width: 108px;
`;
export const TableHeadingThird = styled.th`
  min-width: 155px;
  border-right: none !important;
`;
export const ModalClose = styled.a`
.closeBtn {
  position: absolute;
  right: 30px;
  top: 22px;
  width: 20px;
  height: 20px;
  opacity: 1;
}
.closeBtn:before, .closeBtn:after {
  position: absolute;
  left: 10px;
  top: -3px;
  content: ' ';
  height: 25px;
  width: 1px;
  background-color: ${props => props.theme.colors.lightblack};
}
.closeBtn:before {
  transform: rotate(45deg);
}
.closeBtn:after {
  transform: rotate(-45deg);

}
@media only screen and (max-width: 767px) {
  display: none;
}
`;
export const TableDescription = styled.td`
  border-right: 1px solid ${props => props.theme.border.filledTabsInactive};
  border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
  text-align: right;
  padding: 11px 30px 10px 10px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
`;
export const AccessTableWrapper = styled(Col)`
  margin-bottom: 20px;
`;